import { CONTENTFUL_SPACE } from 'config/contentful';

/**
 * Environment values shared by every shop and every environment.
 * Locale/environment-specific values live in the per-shop common-environment files.
 */
export default {
  contentfulSpace: CONTENTFUL_SPACE,
  ninetailedApiKey: 'b68d0d4d-2053-409f-9a36-ce2401ee289f',
};
